<template>
  <header
    class="header"
    :class="{ opacity, colored, simple, metamask }"
  >
    <div class="container">
      <div class="header-inner">
        <div class="header-left">
          <router-link :to="{ name: 'HomePage' }" class="logo">
            <img
              class="logo-img"
              src="/public/img/logoLogin.svg"
              width="130"
              height="33"
              loading="lazy"
              alt="logo"
            />
          </router-link>
          <!-- <button @click="showToken">Show Token</button> -->
        </div>
        <div class="header-navigation">
          <span v-if="isAuthenticated" id="login-link" class="login-link">
            <a href="#" @click.prevent="toMyProfile">
              <template v-if="userAvatar">
                <img
                  :src="userAvatar"
                  width="24"
                  height="24"
                  loading="lazy"
                  alt="avatar"
                  class="avatar"
                />
              </template>
              <svg
                v-else
                class="avatar"
                width="28"
                height="27"
                viewBox="0 0 28 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.0009 26.8709C21.3225 26.8709 27.2713 20.922 27.2713 13.6005C27.2713 6.27894 21.3224 0.330078 14.0009 0.330078C6.67933 0.330078 0.730469 6.27894 0.730469 13.6005C0.730469 20.922 6.67933 26.8709 14.0009 26.8709ZM6.67927 21.9781C8.68579 19.5844 11.2904 18.282 14.0009 18.282C16.7113 18.282 19.316 19.5844 21.3225 21.9781C19.3864 23.7028 16.8169 24.7588 14.0009 24.7588C11.1849 24.7588 8.61527 23.7027 6.67927 21.9781ZM14.0009 2.44208C20.1609 2.44208 25.1593 7.44048 25.1593 13.6005C25.1593 16.17 24.2793 18.5637 22.8009 20.4293C20.372 17.6837 17.3097 16.17 14.0009 16.17C10.692 16.17 7.62967 17.6834 5.20087 20.4293C3.72247 18.5286 2.84247 16.17 2.84247 13.6005C2.84247 7.44048 7.84087 2.44208 14.0009 2.44208Z"
                  fill="black"
                />
                <path
                  d="M14.0009 15.115C16.9576 15.115 19.3513 12.7215 19.3513 9.76453C19.3513 6.80779 16.9578 4.41406 14.0009 4.41406C11.0441 4.41406 8.65039 6.80754 8.65039 9.76453C8.65039 12.7215 11.0441 15.115 14.0009 15.115ZM14.0009 6.52619C15.796 6.52619 17.2393 7.96945 17.2393 9.76459C17.2393 11.5597 15.796 13.003 14.0009 13.003C12.2057 13.003 10.7625 11.5597 10.7625 9.76459C10.7625 8.00459 12.2057 6.52619 14.0009 6.52619Z"
                  fill="black"
                />
              </svg>
              <span class="username">
                {{ currentUser.username }}
              </span>
            </a>
          </span>
          <template v-if="!simple">
            <Teleport
              v-if="isAuthenticated && !simple"
              to="#coins-mobile"
              :disabled="teleportDisable"
            >
              <div v-show="currency" class="coins-wrapper">
                <button
                  class="coins pixcoin-icon"
                  @click="purchaseModalOpen(false)"
                >
                  <number
                    ref="pixcoins"
                    :from="oldPxValue"
                    :to="newPxValue"
                    :duration="duration"
                    :delay="delay"
                    animationPaused
                    @complete="counterAnimation('pixcoins')"
                    easing="Power1.easeOut"
                    class="coins-value"
                  />
                </button>
              </div>
            </Teleport>
          </template>
          <span v-if="!isAuthenticated" id="login-link" class="login-link">
            <a href="#" @click.prevent="toMyProfile">
              <svg
                class="avatar"
                width="28"
                height="27"
                viewBox="0 0 28 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.0009 26.8709C21.3225 26.8709 27.2713 20.922 27.2713 13.6005C27.2713 6.27894 21.3224 0.330078 14.0009 0.330078C6.67933 0.330078 0.730469 6.27894 0.730469 13.6005C0.730469 20.922 6.67933 26.8709 14.0009 26.8709ZM6.67927 21.9781C8.68579 19.5844 11.2904 18.282 14.0009 18.282C16.7113 18.282 19.316 19.5844 21.3225 21.9781C19.3864 23.7028 16.8169 24.7588 14.0009 24.7588C11.1849 24.7588 8.61527 23.7027 6.67927 21.9781ZM14.0009 2.44208C20.1609 2.44208 25.1593 7.44048 25.1593 13.6005C25.1593 16.17 24.2793 18.5637 22.8009 20.4293C20.372 17.6837 17.3097 16.17 14.0009 16.17C10.692 16.17 7.62967 17.6834 5.20087 20.4293C3.72247 18.5286 2.84247 16.17 2.84247 13.6005C2.84247 7.44048 7.84087 2.44208 14.0009 2.44208Z"
                  fill="black"
                />
                <path
                  d="M14.0009 15.115C16.9576 15.115 19.3513 12.7215 19.3513 9.76453C19.3513 6.80779 16.9578 4.41406 14.0009 4.41406C11.0441 4.41406 8.65039 6.80754 8.65039 9.76453C8.65039 12.7215 11.0441 15.115 14.0009 15.115ZM14.0009 6.52619C15.796 6.52619 17.2393 7.96945 17.2393 9.76459C17.2393 11.5597 15.796 13.003 14.0009 13.003C12.2057 13.003 10.7625 11.5597 10.7625 9.76459C10.7625 8.00459 12.2057 6.52619 14.0009 6.52619Z"
                  fill="black"
                />
              </svg>
              <span class="username"> Login </span>
            </a>
          </span>
          <button
            v-if="headerType !== 'metamaskTemplate'"
            v-show="!opacity"
            @click="menuToggle"
            class="burger"
          >
            <svg
              width="29"
              height="20"
              viewBox="0 0 29 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 10H27"
                stroke="black"
                stroke-width="3.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2 2H27"
                stroke="black"
                stroke-width="3.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2 18H27"
                stroke="black"
                stroke-width="3.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <PurchaseModal
      v-if="purchaseModal"
      :pixtokens="pixtokens"
      @modalClose="purchaseModalClose"
      @currencyUpdateCheck="currencyUpdateCheck"
    />
    <SuccessBuyModal
      v-if="successBuy"
      :data="successBuyData"
      @modalClose="successBuyModalClose"
    />
  </header>
</template>

<script>
import { mapGetters } from 'vuex';

import DropdownMenu from '../dropdown/dropdown-menu.vue';
import IosLink from '../../components/ui/app-ios.vue';
import AndroidLink from '../../components/ui/app-android.vue';
import SuccessBuyModal from '../../components/modals/successBuyModal.vue';
import PurchaseModal from '../modals/purchaseModal.vue';

import services from '../../../services';
import { mobileDetect } from '../../functions/mobileDetect';

import Teleport from 'vue2-teleport';

export default {
  components: {
    DropdownMenu,
    IosLink,
    AndroidLink,
    PurchaseModal,
    SuccessBuyModal,
    Teleport,
  },

  props: {
    headerType: {
      type: String,
      required: true,
    },

    authKey: {
      type: Boolean,
      default: false,
    },

    opacity: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      purchaseModal: false,
      menuOpen: false,
      userAvatar: null,
      pixtokens: false,
      oldPxValue: 0,
      newPxValue: 0,
      oldPxtValue: 0,
      newPxtValue: 0,
      duration: 3,
      delay: 2,
      isMobile: mobileDetect(),
      locStor: localStorage.getItem('token'),
      windowWidth: window.innerWidth,
      successBuyData: {
        usd: '',
        coins: '',
        before: '',
        current: '',
      },
      successBuy: false,
    };
  },

  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'currentUser']),
    ...mapGetters(['currency']),

    teleportDisable() {
      return this.windowWidth > 1200;
    },

    isProfilePage() {
      return this.$route.meta.isProfile && this.isAuthenticated;
    },

    isMetamaskMobile() {
      return this.isMobile && this.headerType === 'metamaskTemplate';
    },

    simple() {
      return (
        this.headerType === 'paymentTemplate' ||
        this.headerType === 'metamaskTemplate'
      );
    },

    metamask() {
      return this.headerType === 'metamaskTemplate';
    },

    name() {
      return this.data;
    },

    colored() {
      return this.$route.meta.colored || false;
    },
  },

  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },

    showToken() {
      alert(localStorage.getItem('token'));
    },

    successBuyModalClose() {
      localStorage.removeItem('isAvatarCam');
      this.successBuy = false;
    },

    counterAnimation(ref) {
      const element = this.$refs[ref].$el.parentElement;

      element.classList.add('pulse');

      setTimeout(() => element.classList.remove('pulse'), 1000);
    },

    purchaseModalOpen(pixtokens) {
      this.pixtokens = pixtokens;
      this.purchaseModal = true;

      this.$emit('mobileMenuClose');
    },

    purchaseModalClose() {
      this.purchaseModal = false;
    },

    toMyProfile() {
      if (this.isAuthenticated) {
        this.$router.push({
          name: 'Profile',
          query: {
            tab: 'albums',
            type: 'private',
          },
        });
      } else {
        this.$emit('goToLogin');
      }
    },

    goToChangePass() {
      this.$emit('goToChangePass');
    },

    goToInvite() {
      this.$emit('goToInvite');
    },

    goToLogin() {
      this.$emit('goToLogin');
    },

    menuToggle() {
      this.$emit('menuToggle');
    },

    logout() {
      this.$emit('logout');
    },

    async getAvatar() {
      const userObject = JSON.parse(localStorage.getItem('vuex')).auth.user;

      if (userObject && userObject !== 'undefined') {
        const userId = userObject.id;

        const user = await services.user.fetchUser(userId);

        this.userAvatar = user.profile_image ? user.profile_image.url : null;
      }
    },

    currencyUpdateCheck(checker, oldValue, bundle) {
      console.log(checker, oldValue, bundle);
      this.purchaseModalClose();

      const valueUpdateCheck = () => {
        setTimeout(async () => {
          await this.$store.dispatch('getCurrency');

          if (this.currency[checker] === oldValue) {
            valueUpdateCheck();

            return;
          }

          if (checker === 'pixcoins') {
            this.successBuyData = {
              usd: bundle.price,
              coins: Number(bundle.coins),
              before: oldValue,
              current: oldValue + Number(bundle.coins),
            };

            this.successBuy = true;

            return;
          }

          const currencyName =
            checker === 'pixcoins' ? 'Pixcoins' : 'Pixtokens';

          const currencyDiff = this.currency[checker] - oldValue;

          const payload = {
            active: true,
            type: 'success',
            text: `${currencyDiff} ${currencyName} added to your account.`,
          };

          this.$store.dispatch('setToast', payload);
        }, 5000);
      };

      valueUpdateCheck();
    },
  },

  mounted() {
    localStorage.removeItem('isAvatarCam');

    this.getAvatar();
    if (this.isAuthenticated && !this.simple)
      this.$store.dispatch('getCurrency');

    window.addEventListener('resize', this.onResize);
  },

  beforeDestroy() {
    localStorage.removeItem('isAvatarCam');
  },

  watch: {
    authKey() {
      this.getAvatar();
    },

    isAuthenticated() {
      this.getAvatar();
    },

    simple(value) {
      if (!value) this.$store.dispatch('getCurrency');
    },

    currency: {
      handler(newValue, oldValue) {
        if (!this.simple && this.isAuthenticated) {
          if (localStorage.getItem('logOut')) {
            this.duration = 0;
            this.delay = 0;

            localStorage.removeItem('logOut');
          } else {
            this.duration = 3;
            this.delay = 2;
          }

          if (oldValue) {
            this.oldPxtValue = oldValue.pixtokens ? oldValue.pixtokens : 0;
            this.oldPxValue = oldValue.pixcoins ? oldValue.pixcoins : 0;
          }

          if (newValue) {
            this.newPxtValue = newValue.pixtokens ? newValue.pixtokens : 0;
            this.newPxValue = newValue.pixcoins ? newValue.pixcoins : 0;
          }

          setTimeout(() => {
            this.$refs.pixcoins.play();
          }, 0);
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped>
.container {
  position: relative;
  margin: 0 auto;
  padding: 0 30px;
  max-width: 1310px;
  height: 100%;
  box-sizing: border-box;
}

.logo {
  display: flex;
  align-items: center;
}

.logo-img {
  margin-right: 7px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
}

@media (max-width: 991px) {
  .container {
    padding: 0 38px;
  }
}

@media (max-width: 767px) {
  .container {
    padding: 0 19px;
  }
}

.header {
  padding: 16px 0;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 71px;
  background: #fff;
  /* height: 129px; */
}

.simple .header-left,
.simple .header-navigation {
  position: relative;
  z-index: 1;
}

.header.colored {
  background: #f5f7f9;
}

@media (min-width: 992px) {
  .simple:before,
  .simple:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .simple:before {
    background: url('../../../../public/img/metamask/background-1.svg');
    opacity: 1;
    animation: 3s fadeIn linear infinite;
  }

  .simple:not(.metamask):after {
    background: url('../../../../public/img/metamask/background-2.svg');
    opacity: 0;
    animation: 3s fadeOut linear infinite;
  }
}

@media (min-width: 1200px) {
    .simple.metamask {
      background: none;
    }
}

@media (max-width: 767px) {
  .simple.metamask {
    background: #fff;
    z-index: 1000;
  }
}

.header.opacity {
  background: none;
  z-index: 102;
  pointer-events: none;
}

.header.opacity a {
  pointer-events: initial;
}

@media (max-width: 991px) {
  .header.opacity {
    background: #f8f8f8;
  }
}

.header-left {
  display: flex;
  align-items: center;
}

.header-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

@media (max-width: 767px) {
  .header-inner {
    padding-right: 0;
  }
}

.header-navigation {
  display: flex;
  align-items: center;
}

.login-link {
  display: flex;
  align-items: center;
  color: #000;
  font-family: SF Pro Display;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 21px;
  text-decoration: none;
}

.login-link a {
  display: flex;
  color: #000;
  font-family: SF Pro Display;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 21px;
  text-decoration: none;
}

.login-link.simple {
  justify-content: flex-end;
}

@media (max-width: 375px) {
  .login-link {
    margin-right: 7px;
    min-width: 80px;
  }
}

.avatar {
  margin-right: 7px;
  border-radius: 100%;
}

.burger-button {
  margin-left: 6px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 19px;
  background: none;
  border: none;
  cursor: pointer;
  position: relative;
  bottom: 2px;
}

@media (max-width: 767px) {
  .burger-button {
    height: 29px;
  }

  .icon-desktop {
    display: none;
  }
}

@media (min-width: 768px) {
  .icon-mobile {
    display: none;
  }
}

.app-links {
  margin-right: 20px;
  display: flex;
}

@media (max-width: 767px) {
  .mobile-hide {
    display: none;
  }
}

.burger {
  display: flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  height: 27px;
}

.router-link-active {
  color: #3a48ed;
}

@media (max-width: 767px) {
  #login-link {
    display: none;
  }
}

.coins-wrapper {
  margin-right: 17px;
  display: flex;
}

.coins {
  padding: 2px 4px;
  min-width: 62px;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 12px;
  line-height: 14px;
  background: #000;
  border: none;
  border-radius: 17px;
  box-sizing: border-box;
  cursor: pointer;
  transition: 500ms transform ease;
}

.coins.pulse {
  animation: pulse-black 1s;
}

@keyframes pulse-black {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
    transform: scale(1.1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

.coins:first-child {
  margin-right: 10px;
}

.coins-value {
  padding: 0 4px;
  flex-grow: 1;
  text-align: center;
}

.coins:not(:last-child) {
  margin-right: 10px;
}

.nft-icon:after {
  content: url('../../../../public/img/icons/nft-icon.svg');
  position: relative;
  top: 1px;
  flex-shrink: 0;
}

.pixcoin-icon:after {
  content: '';
  flex-shrink: 0;
  width: 17px;
  height: 17px;
  background-image: url('../../../../public/img/icons/coin.png');
  background-size: cover;
}

.payment-icon {
  margin-left: 5px;
  vertical-align: middle;
}

.username {
  margin-right: 15px;
  line-height: 27px;
}

@keyframes fadeIn {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes fadeOut {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>
